@if (mode === 'renderer') {
  <div
    class="image-dc"
    (click)="btnClick($event, element.fields.link)"
    [class.cursor-pointer]="element.fields.link"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor,
      'height.px': !element.fields.responsive ? element.fields.height: null,
      'background-image': !element.fields.responsive && element.fields.image ? 'url(' + element.fields.image + ')' : null
    }"
  >
    @if (edit && !element.fields.image) {
      <div class="text-center">Upload image on the right -></div>
    }
    @if(element.fields.responsive){
        <img [src]="element.fields.image">
    }
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <div class="d-flex justify-content-between">
                <div class="form-group">
                  <label [for]="idUploadInput">Image</label>
                  <input type="text" class="form-control" id="{{ idUploadInput }}" [(ngModel)]="element.fields.image" />
                </div>

                <div (click)="uploadImage()" class="cursor-pointer upload-image">
                  <i class="fa-solid fa-upload"></i>
                </div>
              </div>
            </div>
            @if(!element.fields.responsive){
                <div class="col-12">
                    <lib-gung-number-input
                      [gungTranslate]="'Fixed height'"
                      [(ngModel)]="element.fields.height"
                    ></lib-gung-number-input>
                  </div>
            }
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.responsive"
                  id="responsive"
                />
                <label class="form-check-label" for="responsive">Responsive</label>
              </div>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Link'"
                [(ngModel)]="element.fields.link"
              ></lib-gung-text-input>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <div class="row">
                  <lib-dynamic-page-element-margin-padding
                    [(marginTop)]="element.fields.marginTop"
                    [(marginRight)]="element.fields.marginRight"
                    [(marginBottom)]="element.fields.marginBottom"
                    [(marginLeft)]="element.fields.marginLeft"
                    [(paddingTop)]="element.fields.paddingTop"
                    [(paddingRight)]="element.fields.paddingRight"
                    [(paddingBottom)]="element.fields.paddingBottom"
                    [(paddingLeft)]="element.fields.paddingLeft"
                  ></lib-dynamic-page-element-margin-padding>
                  <div class="col-12">
                    <div class="d-flex color-dp-input">
                      <lib-gung-text-input
                        [gungTranslate]="'BACKGROUND'"
                        [(ngModel)]="element.fields.background"
                      ></lib-gung-text-input>
                      <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                    </div>
                  </div>
                </div>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-regular fa-image-landscape"></i>
  </div>
}
